import { render, staticRenderFns } from "./EntityEditor.vue?vue&type=template&id=08ddd7f5&scoped=true"
import script from "./EntityEditor.vue?vue&type=script&lang=js"
export * from "./EntityEditor.vue?vue&type=script&lang=js"
import style0 from "./EntityEditor.vue?vue&type=style&index=0&id=08ddd7f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ddd7f5",
  null
  
)

export default component.exports